import React, { Component, Fragment } from "react"
import { Row, Col, Card, CardBody, CardTitle, Form, Label, Button, Modal, ModalHeader, Input, ModalBody, ModalFooter, Table, Badge } from "reactstrap"
import { bcrypt, uInfo, uToken } from "../../useToken";
import { ApiUrl, ProductName, AttachementsUrl } from "../../config";
import { toast, ToastContainer, Flip } from "react-toastify";
import ProfileSettings from "../Authentication/profile-sidebar";
import Loader from "react-loader";
import { Link } from "react-router-dom";
import swal from "sweetalert";
import ReactDatatable from "@ashvin27/react-datatable";
import SunEditor, { buttonList } from 'suneditor-react';
import 'suneditor/dist/css/suneditor.min.css';
export default class ManageBlogs extends Component {
    constructor(props) {
        super(props);
        this.columns = [
            {
                text: "Id#",
                key: "id",
                cell: (record, index) => {
                    return index + 1;
                }
            },
            {
                text: "Image",
                key: "image",
                cell: (record, index) => {
                    return (
                        <a href={`${AttachementsUrl}/user_${record.user_id}/products/${record.image}`} target={'_blank'}>
                            <img width={50} height={50} src={`${AttachementsUrl}/user_${record.user_id}/products/${record.image}`} className="img img-thumbnail" />
                        </a>
                    )
                }
            },
            {
                text: "Title",
                key: "title",
            },
            {
                text: "Status",
                key: "status",
                cell: (record, index) => {
                    if (record.status == 'Publish') {
                        return <p key={index} className="badge bg-success">{record.status}</p>
                    } else if (record.status == 'Unpublish') {
                        return <p key={index} className="badge bg-danger">{record.status}</p>
                    } else {
                        return <p key={index}>{record.status}</p>
                    }
                }
            },
            {
                text: "Created Date",
                key: "created_at",
            },
            {
                key: "action",
                text: "Action",
                cell: (record, index) => {
                    return (
                        <Fragment>
                            <button onClick={() => { this.setState({ row: record, modal: true }) }} className="btn btn-sm btn-secondary mr-5">
                                <i className="fas fa-edit"></i>
                            </button>
                            <button onClick={() => { this.removeProduct(record.id) }} className="btn btn-sm btn-danger">
                                <i className="fas fa-trash"></i>
                            </button>
                            {/* )} */}
                        </Fragment>
                    );
                }
            },
        ];
        this.config = {
            page_size: 10,
            length_menu: [10, 20, 50, 100],
            show_filter: true,
            show_pagination: true,
            button: {
                excel: false,
                print: false,
                csv: false,
            },
        };
        this.state = {
            records: [],
            loader: true,
            page_name: 'Blog listings',
            modal: false,
            modal2: false,
            row: {
                id: '',
                title: '',
                description: '',
                image: 0
            }
        }
    }


    componentDidMount() {
        this.getData();
    }

    getData = () => {
        fetch(`${ApiUrl}` + 'get/products', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ` + uToken()
            },
        })
            .then((response) => response.json())
            .then((response) => {
                if (response.status === true) {

                    this.setState({
                        records: response.data.records,
                    });

                } else {
                    swal({
                        title: response.message,
                        icon: "warning",
                    });
                    // toast(response.message, { hideProgressBar: true, position: "top-center", transition: Flip, className: 'toast-custom-cls error' });
                }

            })
            .catch((error) => {
                console.error('Error:', error);
            });

    }

    submitPage = (event) => {
        event.preventDefault();
        const formData = new FormData(event.currentTarget);
        const submitData = new FormData();
        for (let [key, value] of formData.entries()) {
            submitData.append(key, value);
        }
        fetch(`${ApiUrl}` + "add/product", {
            method: "POST",
            headers: {
                Authorization: `Bearer ` + uToken(),
            },
            body: submitData,
        })
            .then((response) => response.json())
            //Then with the data from the response in JSON...
            .then((data) => {
                if (data.status === true) {
                    this.setState({
                        row: {
                            id: '',
                            title: '',
                            description: '',
                            image: 0
                        },
                        modal: false
                    })
                    this.getData();
                } else {
                    swal({
                        title: data.message,
                        icon: "warning",
                    });
                    // toast(data.message, { hideProgressBar: true, position: "top-center", transition: Flip, className: 'toast-custom-cls error' });
                }
                this.setState({ loader: true });
            })
            //Then with the error genereted...
            .catch((error) => {
                this.setState({ loader: true });

                console.error("Error:", error);
            });
    }

    removeProduct = (id) => {
        swal({
            title: "Are you sure?",
            text: "You want to remove this record.",
            icon: "warning",
            buttons: true,
            dangerMode: true,
        })
            .then((confirmation) => {
                if (confirmation) {
                    fetch(`${ApiUrl}` + "delete/product", {
                        method: "POST",
                        headers: {
                            Accept: "application/json",
                            "Content-Type": "application/json",
                            Authorization: `Bearer ` + uToken(),
                        },
                        body: JSON.stringify({ id: id }),
                    })
                        .then((response) => response.json())
                        //Then with the data from the response in JSON...
                        .then((data) => {
                            if (data.status === true) {
                                this.getData();

                                // toast.success(data.message, {
                                //   theme: "colored",
                                //   autoClose: ToastAutoClose,
                                // });
                            } else {
                                swal({
                                    title: data.message,
                                    icon: "warning",
                                });
                            }
                        })
                        //Then with the error genereted...
                        .catch((error) => {
                            console.error("Error:", error);
                        });
                }
            });
    }
    render() {
        return (
            <React.Fragment>
                <Row>
                    <Col lg="2" className="pl-0">
                        <ProfileSettings menuOpen={false} props={this.props} />
                    </Col>
                    <Col lg="10">
                        <Loader loaded={this.state.loader}></Loader>
                        <Row>
                            <Col sm={6} >
                                <div className="page-title-box">
                                    <h4> {this.state.page_name} </h4>
                                    <ol className="breadcrumb m-0" >
                                        <li key={0} className="breadcrumb-item active"> {ProductName} </li>
                                        <li key={1} className="breadcrumb-item"> < Link to="#"> {this.state.page_name} </Link></li>
                                    </ol>
                                </div>
                            </Col>
                            <Col sm={6}>
                                <div className="page-title-box text-align-right ">
                                    <Button type="button"
                                        color="info"
                                        onClick={
                                            () => this.setState({
                                                modal: true, row: {
                                                    id: '',
                                                    title: '',
                                                    description: '',
                                                    image: 0
                                                }
                                            })}>
                                        <i class="mdi mdi-plus"></i> Create
                                    </Button>
                                </div>


                            </Col>
                        </Row>

                        <Modal
                            isOpen={this.state.modal}
                            fade={false}
                            toggle={() => this.setState({ modal: false })}
                        >
                            <form onSubmit={this.submitPage} method="post"
                                encType="multipart/form-data" className="form-horizontal" id="selection-myform">
                                <ModalBody>
                                    <Row>
                                        <Col md="12">
                                            <div className="form-group mb-3">
                                                <label>Post Title</label>
                                                <input
                                                    name="title"
                                                    defaultValue={this.state.row.title}
                                                    className="form-control"
                                                    placeholder="Enter title"
                                                    required
                                                />
                                                <input
                                                    name="id"
                                                    defaultValue={this.state.row.id}
                                                    type='hidden'
                                                />
                                            </div>
                                        </Col>

                                        <Col md="12">
                                            <div className="form-group mb-3">
                                                <label>Post Description</label>
                                                <SunEditor
                                                    name="description"
                                                    setOptions={{
                                                        height: 250,
                                                        buttonList: [
                                                            ['undo', 'redo', 'font', 'fontSize', 'formatBlock'],
                                                            ['bold', 'underline', 'italic', 'strike', 'subscript', 'superscript', 'removeFormat'],
                                                            ['fontColor', 'hiliteColor', 'outdent', 'indent', 'align', 'horizontalRule', 'list', 'table'],
                                                        ]
                                                    }}
                                                    setContents={this.state.row.description ?? ''}
                                                />

                                                {/* <textarea
                                                    defaultValue={this.state.row.description}
                                                    name="description"
                                                    className="form-control"
                                                    placeholder="Enter description"
                                                    required
                                                    rows={8}
                                                /> */}
                                            </div>
                                        </Col>

                                        <fieldset>
                                            <Col md="12">
                                                <div className="form-group mb-3">
                                                    <label>Meta keywords</label>
                                                    <input
                                                        name="meta_keywords"
                                                        defaultValue={this.state.row.meta_keywords}
                                                        className="form-control"
                                                        placeholder="E.g blog, seo, etc"
                                                    />
                                                </div>
                                            </Col>


                                            <Col md="12">
                                                <div className="form-group mb-3">
                                                    <label>Meta Description</label>
                                                    <textarea
                                                        defaultValue={this.state.row.meta_description}
                                                        name="meta_description"
                                                        className="form-control"
                                                        placeholder="Enter meta description"
                                                        rows={5}
                                                        maxLength={180}
                                                    />
                                                </div>
                                            </Col>
                                        </fieldset>





                                        <Col md="12">
                                            <div className="form-group mb-3">
                                                <label>Image</label>
                                                <input
                                                    name="image"
                                                    className="form-control"
                                                    placeholder="Enter title"
                                                    type={'file'}
                                                />
                                                {
                                                    this.state.row.image != 0 && (
                                                        <img width={"200px"} src={`${AttachementsUrl}/user_${this.state.row.user_id}/products/${this.state.row.image}`} className="img img-thumbnaikl" />
                                                    )
                                                }
                                            </div>
                                        </Col>
                                        <Col md="12">
                                            <div className="form-group mb-3">
                                                <label>Status</label>
                                                <select name="status" className="form-control" defaultValue={this.state.row.status}>
                                                    <option value={'Publish'}>Publish</option>
                                                    <option value={'Unpublish'}>Unpublish</option>
                                                </select>
                                            </div>
                                        </Col>
                                    </Row>
                                </ModalBody>
                                <ModalFooter>
                                    <Button
                                        color="info"
                                        type="submit"
                                    >
                                        Submit
                                    </Button>
                                    <Button
                                        color="danger"
                                        type="button"
                                        onClick={() => this.setState({ modal: false })}
                                    >
                                        Cancel
                                    </Button>
                                </ModalFooter>
                            </form>
                        </Modal>

                        <Card>
                            <CardBody>
                                <ReactDatatable
                                    config={this.config}
                                    records={this.state.records}
                                    columns={this.columns}
                                />
                                <table className="table table-border d-none">
                                    <thead>
                                        <tr>
                                            <th>sr#</th>
                                            <th>Image</th>
                                            <th>Name</th>
                                            {/* <th>Description</th> */}
                                            <th>Status</th>
                                            <th>CREATED DATE</th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.records.map((row, i) => {
                                            return (
                                                <tr key={i}>
                                                    <td>{i + 1}</td>
                                                    <td>
                                                        <a href={`${AttachementsUrl}/user_${row.user_id}/products/${row.image}`} target={'_blank'}>
                                                            <img width={50} height={50} src={`${AttachementsUrl}/user_${row.user_id}/products/${row.image}`} className="img img-thumbnail" />
                                                        </a>
                                                    </td>
                                                    <td>{row.title}</td>
                                                    {/* <td>{row.description}</td> */}
                                                    <td>{row.status}</td>
                                                    <td>{row.created_at}</td>
                                                    <td>

                                                        <button onClick={() => { this.setState({ row: row, modal: true }) }} className="btn btn-sm btn-secondary mr-5">
                                                            <i className="fas fa-edit"></i>
                                                        </button>
                                                        <button onClick={() => { this.removeProduct(row.id) }} className="btn btn-sm btn-danger">
                                                            <i className="fas fa-trash"></i>
                                                        </button>
                                                    </td>
                                                </tr>
                                            )
                                        })}
                                    </tbody>
                                </table>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>

            </React.Fragment >
        )
    }
}